import "./divider.scss";

export function Divider() {
  return <hr className="divider" />;
}
